module.exports = __webpack_public_path__ + "media/images/content/BTN_LINE-01-f2a85b2cc4d5484038189bbfb3b0b43c.svg";